<template>
  <h1 class="system_content_title">菜单管理</h1>
  <div class="system_content_panels">
    <div class="systemPanel" style="position: relative; padding-bottom: 40px">
      <el-form-item>
        <el-button type="primary" @click="infoData.menuShow = true"
          >创建菜单</el-button
        >
      </el-form-item>
    </div>
    <el-table
      :data="infoData.tableData"
      stripe
      border
      :default-expand-all="false"
      row-key="id"
      :tree-props="{ children: 'children' }"
      v-loading="infoData.loading"
	       style="min-height:70vh"
	  
    >
      <el-table-column type="index" width="50" />
      <el-table-column prop="name" label="菜单名称" min-width="200" />
      <el-table-column prop="path" label="路径" width="200" />
      <!-- <el-table-column prop="component" label="子级路径" width="240" /> -->
      <!-- <el-table-column prop="redirect" label="默认路径" width="200" /> -->
      <el-table-column prop="icon" label="图标" width="120">
        <template #default="scope">
          <e-icon :icon-name="scope.row.icon" />
        </template>
      </el-table-column>
      <el-table-column prop="mLevel" label="菜单等级" width="100" />
      <el-table-column prop="sequence" label="排序" width="100" />
      <el-table-column width="200" fixed="right" label="操作">
        <template #default="scope">
          <el-button
            type="success"
            size="small"
            @click="handleClickEdit(scope.row)"
            >编辑</el-button
          >
          <el-popconfirm
            title="确定删除吗?"
            @confirm="handleClickDel(scope.row)"
          >
            <template #reference>
              <el-button type="danger" size="small">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      v-model="infoData.menuShow"
      title="增加/修改菜单"
      width="50%"
      :before-close="handleFcancel"
    >
      <el-form
        v-model="infoData.form"
        label-position="left"
        label-width="100px"
      >
        <el-form-item label="父级目录">
          <el-cascader
            v-model="infoData.form.parentId"
            :options="infoData.menuList"
            :props="{ checkStrictly: true, value: 'id', label: 'name' }"
            @change="handleChange"
            clearable
            placeholder="请选择父级目录(不选就是根目录)"
          >
            <template #default="{ node, data }">
              <span>{{ data.name }}</span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item label="菜单名称">
          <el-input
            v-model="infoData.form.name"
            placeholder="请输入菜单名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="路径">
          <el-input
            v-model="infoData.form.path"
            placeholder="例:/system/menu"
            clearable
          />
        </el-form-item>
        <!-- <el-form-item label="子级路径">
					<el-input v-model="infoData.form.component" placeholder="(必须加上“/”)" clearable />
				</el-form-item>
				<el-form-item label="默认路径">
					<el-input v-model="infoData.form.redirect" placeholder="(必须加上“/”)" clearable />
				</el-form-item> -->
        <el-form-item>
          <el-switch
            v-model="infoData.checkSwitch"
            active-text="插件图标"
            inactive-text="自定义图标"
          />
        </el-form-item>
        <el-form-item label="图标" v-if="infoData.checkSwitch">
          <div>
            <e-icon-picker v-model="infoData.form.icon" />
          </div>
        </el-form-item>
        <el-form-item label="图标" v-else-if="!infoData.checkSwitch">
          <el-input
            v-model="infoData.form.icon"
            placeholder="请输入图标"
            clearable
          />
        </el-form-item>

        <el-form-item label="菜单等级">
          <el-input-number
            v-model="infoData.form.mLevel"
            :min="0"
            label="请输入菜单等级"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number
            v-model="infoData.form.sequence"
            :min="0"
            label="请输入排序"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleFcancel">取 消</el-button>
        <el-button
          type="primary"
          :loading="infoData.loading"
          @click="handleEdit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue-demi";
import api from "../../http/apis";
import { ElMessageBox, ElMessage } from "element-plus";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    const infoData = reactive({
      tableData: [],
      menuShow: false,
      loading: false,
      menuList: [],
      form: {
        icon: "",
      },
      checkSwitch: true,
    });

    const getUserMenu = async () => {
      infoData.tableData = [];
      infoData.loading = true;
      const { data } = await api.menuApi.getMenuTree();
      if (data.isSuccessful) {
        infoData.tableData = data.resultObj;
        infoData.menuList = data.resultObj;
        infoData.loading = false;
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    };
    getUserMenu();

    const handleClickEdit = (item) => {
      infoData.form = item;
      // console.log(infoData.form)
      infoData.menuShow = true;
    };
    const handleEdit = async () => {
      if (typeof infoData.form.parentId == "object") {
        infoData.form.parentId =
          infoData.form.parentId[infoData.form.parentId.length - 1];
      }
      // console.log(infoData.form)
      const { data } = await api.menuApi.addMenu({
        id: infoData.form.id || 0,
        name: infoData.form.name,
        mLevel: infoData.form.mLevel,
        parentId: infoData.form.parentId || 0,
        sequence: infoData.form.sequence,
        // redirect: infoData.form.redirect || '',
        icon: infoData.form.icon || "",
        actionUrl: infoData.form.path,
        // component: infoData.form.component || '',
        isDisabled: infoData.form.isDisabled || 0,
        fullName: infoData.form.fullName || "",
      });
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        infoData.menuShow = false;
        infoData.form = {};
        loadPage();
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
        infoData.menuShow = false;
        infoData.form = {};
        loadPage();
      } else {
        ElMessage({});
      }
    };

    const handleClickDel = async (info) => {
      const { data } = await api.menuApi.deleteMenu(info.id);
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        getUserMenu();
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    };
    const handleFcancel = () => {
      infoData.menuShow = false;
      infoData.form = {};
    };

    const handleChange = (value) => {
      // console.log(value)
    };
    const loadPage = () => {
      store.dispatch("user/setUserMenu");
    };
    return {
      infoData,
      getUserMenu,
      handleClickEdit,
      handleEdit,
      handleClickDel,
      handleFcancel,
      handleChange,
      loadPage,
    };
  },
};
</script>

<style scoped lang='scss'>
@use "../../assets/scss/table.scss" as *;

.el-input__wrapper {
  width: 300px !important;
}
</style>
